<div class="approval-rule mb-5">
  <mat-card class="lum-mat-card">
    <mat-card-content>
      <div class="p-5">
        <div class="d-flex justify-content-between">
          <div class="align-center flex gap-3">
            <button class="btn btn-icon" routerLink="/settings/system">
              <i class="fa fa-angle-left"></i>
            </button>
            <h3 class="mt-4 inline">Approval Rules</h3>
          </div>
        </div>
        <mat-divider class="my-2"></mat-divider>
      </div>
      <div class="p-5">
        <div class="row">
          <div class="col-6">
            <lum-approval-rule-filters
              class="mb-2"
              (createEvent)="onCreateEvent()"
              (searchEvent)="onSearchEvent($event)"
            ></lum-approval-rule-filters>
          </div>
        </div>

        <ng-container *ngIf="loading === false">
          <lum-approval-rule-table
            *ngIf="data?.length; else empty"
            (deleteEvent)="onDeleteEvent($event)"
            (editEvent)="onEditEvent($event)"
            [data]="data"
          ></lum-approval-rule-table>
          <mat-paginator
            [length]="pagination.total || 0"
            [pageSize]="pagination.per_page || paginationConfig.perPage"
            [pageSizeOptions]="paginationConfig.pageSizeOptions"
            [pageIndex]="(pagination.current_page || 1) - 1"
            (page)="onPaginationEvent($event)"
            aria-label="Select page"
          >
          </mat-paginator>
        </ng-container>

        <div
          class="overlay"
          lumAppLoader
          [loading]="loading"
          [classes]="'loading blur'"
        ></div>

        <ng-template #empty>
          <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>
